import { Injectable, Injector } from '@angular/core';
import { Subject, BehaviorSubject, Observable, ReplaySubject } from 'rxjs';

import { BaseComponents } from '../base.component';

// @Injectable()
@Injectable({ providedIn: 'root' })
export class SharedDataService extends BaseComponents {
    constructor(
      protected injectorObj:Injector,
      //private logger: NGXLogger
    ) { 
      super(injectorObj);
    }

    //nonmotor
    public nonmotorDataDetails: any = [];
    private nonmotorSource = new BehaviorSubject(this.nonmotorDataDetails);
    getNonmotorDetail = this.nonmotorSource.asObservable();

    //motor
    public motorDataDetails: any = [];
    private motorSource = new BehaviorSubject(this.motorDataDetails);
    getMotorDetail = this.motorSource.asObservable();

    setNonmotorDetail(data: Array<any>) {
      this.nonmotorSource.next(data)
    }

    setMotorDetail(data: Array<any>) {
        this.motorSource.next(data)
      }
}